<template>
<div class="notification-form flex-grow-1 d-flex flex-column">
  <div class="mt-4" v-if="isLoading">
    <Spinner />
  </div>
  <NotificationForm v-if="!isLoading && notification" :notification="notification" @submit="onSubmit($event)" />
</div>
</template>

<script>
  import NotificationService from '../services/notification.service';
  import NotificationForm from './NotificationForm';

  export default {
    name: 'NotificationEdit',
    components: {
      NotificationForm
    },
    data() {
      return {
        isLoading: true,
        notificationId: this.$route.params.notification,
        notification: null,
      };
    },
    mounted() {
      this.getNotification();
    },
    methods: {
      async onSubmit(event) {
        try {
          await NotificationService.update(this.notificationId, event);  
          this.$router.push('/notification/list');
          this.$showSuccessMessage('Updated Notification');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      },
      async getNotification() {
        try {
          const data = await NotificationService.get(this.notificationId);
          this.notification = {
            id: data.id,
            url_id: data.url_id,
            contact_group_id: data.contact_group_id,
            notification_type: data.notification_type
          };
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        } finally {
          this.isLoading = false;
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
